import axios from "axios";
import { Navigate } from "react-router-dom";

const API_URL = `${process.env.REACT_APP_API_URL}/`;

const axiosApi = axios.create({
  baseURL: API_URL,
});

axiosApi.interceptors.request.use(
  (config) => {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const token = authUser?.token;

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginRequest = error.config?.url?.includes('login');
    if(error.response.status === 401 && !isLoginRequest) {
      localStorage.removeItem("authUser");
      return (
		    <Navigate to={{ pathname: "/login" }} />
		  );
    }
    return Promise.reject(error);
  }
);

export async function get(url, config = {}) {
  try {
    const response = await axiosApi.get(url, config);
    return response.data;
  } catch (err) {
    console.error("GET Error:", err);
    throw err;
  }
}

export async function post(url, data, config = {}) {
  try {
    const response = await axiosApi.post(url, data, config);
    return response.data;
  } catch (err) {
    console.error("POST Error:", err);
    throw err;
  }
}

export async function put(url, data, config = {}) {
  try {
    const response = await axiosApi.put(url, data, config);
    return response.data;
  } catch (err) {
    console.error("PUT Error:", err);
    throw err;
  }
}

export async function del(url, config = {}) {
  try {
    const response = await axiosApi.delete(url, config);
    return response.data;
  } catch (err) {
    console.error("DELETE Error:", err);
    throw err;
  }
}

export async function getCurrentAssignedNozzel() {
  try {
    const response = await axiosApi.get("/get_assigned_nozzel");
    return response.data;
  } catch (err) {
    console.error("Nozzle API Error:", err);
    throw err;
  }
}
